import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import React, {Fragment} from "react";
import {makeStyles} from "@material-ui/core/styles";
import {useTranslation} from "react-i18next";

const useStyles = makeStyles(theme => ({
    actions: {
        marginTop: theme.spacing(2),
        '& > *': {
            marginRight: theme.spacing(2),
        },
    },
}));

export enum WizardNavigationButton {
    Previous = "Previous",
    Next = "Next",
    Save = "Save",
    Close = "Close"
}

export interface NavigationProps {
    onSubmitChange?: (changeTab: () => void, newValues?: any) => void,
    onChangeTab: (newTabIndex: number) => void,
    onClose: (() => void) | null,
    onSave?: () => void | Promise<void>,
    index: number,
    lastIndex: number
    disabledButtons?: Set<WizardNavigationButton>,
    allCompleted?: boolean
}

const defaultSubmitChange = (changeTab: () => void) => changeTab();

export const WizardNavigation: React.FC<NavigationProps> = ({onSubmitChange = defaultSubmitChange, onChangeTab, onClose, onSave, index, lastIndex, disabledButtons = new Set(), allCompleted = false}) => {
    const classes = useStyles();
    const {t} = useTranslation();

    const goNext = () => {
        if (index === lastIndex) return;
        onChangeTab(index + 1);
    }

    const goPrevious = () => {
        if (index === 0) return;
        onChangeTab(index - 1);
    }

    return <Grid xs={12} item={true} container justify="flex-end" direction="row" className={classes.actions}>
        {onClose &&
        <Button variant="outlined" color="primary" size="medium"
                disabled={disabledButtons.has(WizardNavigationButton.Close)}
                onClick={onClose}>
            {t('_Common.Labels.Close')}
        </Button>}
        {!allCompleted &&
        <Fragment>
            {index > 0 &&
            <Button variant="contained" color="primary" size="medium"
                    disabled={disabledButtons.has(WizardNavigationButton.Previous)}
                    onClick={() => onSubmitChange(goPrevious)}>
                {t('_Common.Labels.Previous')}
            </Button>}
            {index < lastIndex &&
            <Button variant="contained" color="primary" size="medium"
                    disabled={disabledButtons.has(WizardNavigationButton.Next)}
                    onClick={() => onSubmitChange(goNext)}>
                {t('_Common.Labels.Next')}
            </Button>}
            {index === lastIndex &&
            <Button variant="contained" color="primary" size="medium"
                    disabled={disabledButtons.has(WizardNavigationButton.Save)}
                    onClick={onSave}>
                {t('_Common.Labels.Save')}
            </Button>}
        </Fragment>
        }
    </Grid>

}
